import { ConnectedRouter } from 'connected-react-router'
import { History } from 'history'
import { Route, Switch, Redirect } from 'react-router-dom'
import BeforeLoginStepper from './containers/Apartment/BeforeLoginStepper/BeforeLoginStepper'
// import InstantRentApplicationStepper from './containers/Apartment/InstantRentApplication'
import ApartmentOverview from './containers/Apartment/Overview'
import ApartmentStatistics from './containers/Apartment/Statistics'
import Stepper from './containers/Apartment/Stepper'
import Apartments from './containers/Apartments/Apartments'
import EditApplication from './containers/Application/EditApplication/EditApplication'
import Applications from './containers/Applications'
import ConfirmPasswordReset from './containers/Authentication/ForgotPassword/ConfirmPasswordReset'
import RequestPasswordReset from './containers/Authentication/ForgotPassword/RequestPasswordReset'
import Login from './containers/Authentication/Login'
import Signup from './containers/Authentication/Signup'
//import InstantRentApplicationStepper from './containers/InstantRentApplication'
import Messages from './containers/Messages'
import Navigation from './containers/Navigation'
import NewApplication from './containers/NewApplication/NewApplication'
import ApplicationPayment from './containers/NewApplication/ApplicationPayment'
import Profile from './containers/Profile'
import CreateShowings from './containers/Showings/Create'
import ShowingsOverview from './containers/Showings/Overview'
import ReserveShowing from './containers/Showings/Reserve/ReserveShowing'
import SuggestShowingTimes from './containers/Showings/Reserve/SuggestShowingTimes'
import Payment from './containers/PayForPublish/Payment'
import AfterShowingStepper from './containers/AfterShowing'
import ContractGeneratorStepper from './containers/ContractGenerator'
import ApplicantWatcher from './containers/ApplicantWatcher'
import LandlordIdentifier from './containers/LandlordIdentifier/index'
import PublicListing from './containers/Apartment/Overview/PublicListing'

const Routes = () => (
  <Switch>
    <Route exact path='/' component={Login} />
    <Route exact path='/register' component={Signup} />
    <Redirect exact from='/signup' to='/create/apartment' />
    <Route
      exact
      path='/forgotpassword/request'
      component={RequestPasswordReset}
    />
    <Route
      exact
      path='/forgotpassword/reset/:email/:code'
      component={ConfirmPasswordReset}
    />
    <Route exact path='/apartments' component={Apartments} />
    <Route exact path='/adminApartments/:status' component={Apartments} />
    <Route exact path='/adminApartments' component={Apartments} />
    <Route
      exact
      path='/new-application/:apartmentCode'
      component={NewApplication}
    />
    <Route
      exact
      path='/new-application/:apartmentCode/steps/:step'
      component={NewApplication}
    />
    <Route
      exact
      path='/application/:applicationCode/payment'
      component={ApplicationPayment}
    />
    <Route
      exact
      path='/users/:userId/apartments/:apartmentId/applications'
      component={Applications}
    />
    <Route
      exact
      path='/users/:userId/apartments/:apartmentId/messages'
      component={Messages}
    />
    <Route
      exact
      path='/users/:userId/apartments/:apartmentId/showings'
      component={CreateShowings}
    />
    <Route
      exact
      path='/users/:userId/apartments/:apartmentId/showings/overview'
      component={ShowingsOverview}
    />
    <Route
      exact
      path='/users/:userId/apartments/:apartmentId/steps/:step'
      component={Stepper}
    />
    {/* <Redirect exact from='/instant-rent/:step' to='/instant-rent/steps/0' /> */}
    {/* <Route
      exact
      path='/instant-rent/:apartmentCode/steps/:step'
      component={InstantRentApplicationStepper}
    /> */}
    <Redirect exact from='/create/apartment' to='/create/apartment/steps/0' />
    <Route
      exact
      path='/create/apartment/steps/:step'
      component={BeforeLoginStepper}
    />
    <Route
      exact
      path='/users/:userId/apartments/:apartmentId/overview'
      component={ApartmentOverview}
    />
    <Route
      exact
      path='/users/:userId/apartments/:apartmentId/statistic'
      component={ApartmentStatistics}
    />
    <Route
      exact
      path='/application/:applicationId/apartments/:apartmentId/edit'
      component={EditApplication}
    />
    <Route exact path='/reserve/:applicationCode' component={ReserveShowing} />
    <Route
      exact
      path='/reserve/:applicationCode/suggest'
      component={SuggestShowingTimes}
    />
    <Route exact path='/profile' component={Profile} />
    <Route exact path='/messages' component={Messages} />
    <Route
      exact
      path='/users/:userId/apartments/:apartmentId/contract/:applicationCode/steps/:step'
      component={ContractGeneratorStepper}
    />
    <Route
      exact
      path='/users/:userId/apartments/:apartmentId/payment'
      component={Payment}
    />
    <Route
      exact
      path='/aftershowing/:applicationCode/steps/:step'
      component={AfterShowingStepper}
    />
    <Route
      exact
      path='/users/:userId/verification'
      component={LandlordIdentifier}
    />
    <Route
      exact
      path='/listing/:apartmentCode'
      component={PublicListing}
    />
    <Route
      exact
      path="/aftershowing/:applicationCode"
      render={({ match }) => (
        <Redirect to={`/aftershowing/${match.params.applicationCode}/steps/1`} />
      )}
    />
    <Route
      exact
      path='/generatecontract/:applicationCode/steps/:step'
      component={ContractGeneratorStepper}
    />
    <Route
      exact
      path='/tenants'
      component={ApplicantWatcher}
    />
  </Switch>
)

const AppRouter = ({ history }: { history: History<unknown> }) => {
  return (
    <ConnectedRouter history={history}>
      <Navigation Routes={Routes} />
    </ConnectedRouter>
  )
}

export default AppRouter
